var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-center font-small text-secondary"},[_vm._v("Copyright © はなちる All Rights Reserved.")])
}
var staticRenderFns = []

export { render, staticRenderFns }